import React from 'react';
import { Link } from 'react-router-dom';
import { PartyPopper, Sparkles, Fish, Rocket, Cake } from 'lucide-react';
import SubpageShell from './SubpageShell';
import SEO from '../components/SEO';
import PageHeroImage from '../components/PageHeroImage';
import ServiceEnquiryForm from '../components/ServiceEnquiryForm';
import '../styles/ServiceEnquiry.css';

const THEMES = [
  { icon: Rocket, label: 'Cosmic Adventure', body: 'A planet-to-planet celebration — stars, launches and discovery.' },
  { icon: Fish, label: 'Underwater World', body: 'Dive into a reef of colour, calm pace and friendly sea life.' },
  { icon: Sparkles, label: 'Celebration (freeform)', body: 'Tell us the occasion. We design something right for the people in the room.' },
  { icon: Cake, label: 'Birthday themes', body: 'Private, carefully-paced birthday experiences built around your child.' },
];

const ExperiencesEvents = () => (
  <SubpageShell currentPath="/experiences/events">
    <SEO
      title="Celebrations & Events | N3URO WORLD®"
      description="Extraordinary occasions designed with everyone in mind — birthdays, family celebrations and private themed events."
      canonical="/experiences/events"
      image="https://n3uro.world/img/share-experiences-events.jpg"
    />
    <main className="subpage-hero">
      <PageHeroImage src="/img/experiences-events.webp" alt="N3URO Celebrations & Events — children celebrate a space-themed birthday" testId="hero-image-experiences-events" />
      <nav aria-label="Breadcrumb" style={{ fontSize: '0.82rem', color: 'rgba(255,255,255,0.65)', marginBottom: '0.5rem' }}>
        <Link to="/experiences" style={{ color: '#5BE9FF' }}>Experiences</Link> &middot; Celebrations &amp; Events
      </nav>
      <span className="subpage-eyebrow"><PartyPopper size={12} /> &nbsp;Celebrations &amp; Events</span>
      <h1 className="subpage-title">Extraordinary occasions. Designed with everyone in mind.</h1>
      <p className="subpage-lede">
        Birthdays, family celebrations and private occasions, planned with the sensory, access and
        pacing considerations your family deserves. Not an Academy workshop and no membership required.
      </p>

      <section className="service-grid" aria-label="Example event themes">
        {THEMES.map(({ icon: Icon, label, body }) => (
          <article key={label} className="service-card" style={{ '--accent': '#FF6BC2' }}>
            <span className="service-card-icon" aria-hidden="true"><Icon size={22} strokeWidth={1.75} /></span>
            <h3>{label}</h3>
            <p>{body}</p>
          </article>
        ))}
      </section>

      <section id="enquire" aria-label="Event enquiry" style={{ marginTop: '1.5rem' }}>
        <h2 className="subpage-title" style={{ fontSize: 'var(--fs-h2)' }}>Plan your event</h2>
        <ServiceEnquiryForm
          serviceType="events"
          headline="Tell us about your occasion"
          submitLabel="Plan your event"
        />
      </section>
    </main>
  </SubpageShell>
);

export default ExperiencesEvents;
